import {
  DescriptionOutlinedIcon,
  NoRowsOverlay,
  type NoRowsOverlayProps,
} from '@shared/components';

export default function EmptyProctorRequestsOverlay(props: NoRowsOverlayProps) {
  return <NoRowsOverlay icon={DescriptionOutlinedIcon} {...props} />;
}
